const MENUS = [
  {
    id: 'dashboard',
    descricao: 'Dashboard',
    link: 'Dashboard',
    permissoes: ['AcompanhamentoDoSaldo'],
    icone: 'fal fa-chart-line',
  },
  {
    id: 'selecao-de-projeto-de-subsidio',
    descricao: 'Solicitar subsídio',
    link: 'SelecaoDeProjetoDeSubsidio',
    permissoes: ['SolicitacaoDeSubsidio', 'SolicitacaoDeSubsidioParaMcmvCidades'],
    icone: 'fal fa-file-invoice-dollar',
  },
  {
    id: 'lista-de-solicitacoes',
    descricao: 'Solicitações',
    link: 'ListaDeSolicitacoes',
    permissoes: ['VisualizarSolicitacoes'],
    icone: 'fal fa-tasks',
  },
  {
    id: 'lista-de-validacao-de-minuta',
    descricao: 'Minutas',
    link: 'ListaDeValidacaoDeMinutas',
    permissoes: ['ValidacaoDeMinutasDoMcmvCidades'],
    icone: 'fal fa-clipboard-list',
  },
  {
    id: 'lista-de-solicitacoes-para-gerenciamento-do-contrato',
    descricao: 'Contratos',
    link: 'ListaDeSolicitacoesParaGerenciamentoDoContrato',
    permissoes: ['GerenciarContratoDoMcmvCidades'],
    icone: 'fal fa-file-contract',
  },
  {
    id: 'empreendimentos',
    descricao: 'Empreendimentos',
    link: 'ListaDeEmpreendimentos',
    permissoes: ['GerenciarEmprendimento'],
    icone: 'fal fa-building',
  },
  {
    id: 'aportes',
    descricao: 'Aportes',
    link: 'ListaDeAportes',
    permissoes: ['GerenciarDeposito'],
    icone: 'fal fa-sack-dollar',
  },
  {
    id: 'cotas',
    descricao: 'Cotas por cidade',
    link: 'ListaDeCotas',
    permissoes: ['GerenciarCotas'],
    icone: 'fal fa-chart-network',
  },
  {
    id: 'relatorio',
    descricao: 'Relatório',
    link: 'GerarRelatorioDeSolicitacao',
    permissoes: ['GerarRelatorioDeSolicitacoes'],
    icone: 'fal fa-file-excel',
  },
  {
    id: 'assinantes',
    descricao: 'Assinantes',
    link: 'ListaDeAssinantes',
    permissoes: ['GerenciarAssinantes'],
    icone: 'fal fa-pen-nib',
  },
];

export const obterMenuInicial = possuiPermissao =>
  MENUS.find(menu => menu.permissoes.some(permissao => possuiPermissao(permissao)));

export default MENUS;



// WEBPACK FOOTER //
// ./src/utils/menuDoSistema.js